import React, { useEffect, useState } from "react";
import "./index.css";
import { IoIosSearch } from "react-icons/io";
import { Button, Popover } from "antd";
import { useLocation } from "react-router-dom";
import Cookies from "universal-cookie";
import Multiselect from "multiselect-react-dropdown";

// import react icons here
import { IoDocumentTextOutline } from "react-icons/io5";
import { GoClock } from "react-icons/go";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { FaRegCheckCircle } from "react-icons/fa";
import { getWorkOrderCount } from "../../functions/workorder";
import { Select, Space } from "antd";
const Index = ({ children, arg }) => {
  const cookies = new Cookies();
  const token = cookies.get("token");

  // make state here
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [selectedFilters, setSelectedFilters] = useState([]);

  // filter drop-down values
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedJobType, setSelectedJobType] = useState(null);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [reconciliationStatus, setReconciliationStatus] = useState(null);

  const [activeFilterButton, setActiveFilterButton] = useState(null);
  const [isApplyEnabled, setIsApplyEnabled] = useState(false);

  const {
    searchText,
    setSearchText,
    radioData,
    setRadioData,
    fetchFilterAll,
    workorderSearch,
    handleDateSortClick,
    sortOrder,
    setSortOrder,
    totalWorkOrders,
    setCurrentPage,
    setCallRadioData,
    handleDeleteWorkOrder,
    selectedWorkOrderToDelete,
    workOrderCount,
    handleSelectAllTheWorkOrder,
    handleOpenMap,
    debouncedSearch
  } = arg;

  // Update `isApplyEnabled` whenever a filter changes
  useEffect(() => {
    const radioData = [
      selectedUser,
      selectedPriority,
      selectedStatus,
      selectedJobType,
      selectedOwner,
      reconciliationStatus,
    ];
    setIsApplyEnabled(radioData.some((value) => value !== ""));
  }, [
    selectedUser,
    selectedPriority,
    selectedStatus,
    selectedJobType,
    selectedOwner,
    reconciliationStatus,
  ]);

  const handleChange = (e) => {
    // e.preventDefault();
    setSelectedFilter("All");
    setSearchText(e.target.value);
    debouncedSearch(e.target.value);
  };

  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleCheckboxChange = (e) => {
    const [value, category] = e.target.value.split("^");
    const isChecked = e.target.checked;

    if (isChecked) {
      setSelectedFilters((prev) => [...prev, { category, value }]);
      setRadioData((prev) => [...prev, { category, value }]);
      // setSelectedFilter((prev) => [
      //   ...prev,
      //   value,
      // ])
    } else {
      setSelectedFilters((prev) =>
        prev.filter(
          (item) => item.value !== value || item.category !== category
        )
      );
      setRadioData((prev) =>
        prev.filter(
          (item) => item.value !== value || item.category !== category
        )
      );
    }
  };

  const handleButtonFilter = (value) => {
    // console.log("Value", value);
    const radioData = [value];
    setActiveFilterButton(value);
    fetchFilterAll(radioData).then(() => {
      hide();
    });
  };

  const handleResetApplyFilter = () => {
    const radioData = [];
    // Fetch filtered data with the selected values
    fetchFilterAll(radioData).then(() => {
      setSelectedUser([]);
      setSelectedPriority([]);
      setSelectedStatus([]);
      setSelectedJobType([]);
      setSelectedOwner([]);
      setReconciliationStatus([]);
      hide();
    });
  };

  const handleApplyFilters = () => {
    const radioData = [
      { category: "userId", value: selectedUser },
      { category: "priority", value: selectedPriority },
      { category: "apptStatus", value: selectedStatus },
      { category: "jobType", value: selectedJobType },
      { category: "owner", value: selectedOwner },
      { category: "reconciliationStatus", value: reconciliationStatus },
    ];

    // Check if any filter has a non-empty value
    const hasActiveFilters = radioData.some((filter) => filter.value);

    // Set selected filter type based on active filters
    const filterType = hasActiveFilters ? "Custom" : "All";
    setSelectedFilter(filterType);

    // Reset pagination and sorting
    setCurrentPage(1);
    setSortOrder("");

    // Fetch filtered data with the selected values only if there's an active filter
    if (filterType === "Custom") {
      fetchFilterAll(radioData).then(() => {
        hide();
      });
    }
  };

  const contentData = () => (
    <div style={{ width: "25rem" }}>
      <div className="d-flex justify-content-between">
        <button
          style={{
            color: "blue",
            border: "none",
            background: "none",
            fontWeight: "bold",
          }}
          onClick={handleResetApplyFilter}
        >
          Reset
        </button>
        <p className="fw-bold">Filter Jobs</p> {/* Bootstrap class for bold */}
        <button
          style={{
            fontWeight: "bold",
            color: isApplyEnabled ? "blue" : "gray",
            border: "none",
            background: "none",
            cursor: isApplyEnabled ? "pointer" : "not-allowed", // Changes cursor style
          }}
          onClick={handleApplyFilters}
          disabled={!isApplyEnabled}
        >
          Apply
        </button>
      </div>

      <div>
        <label htmlFor="">USER</label>
        <div className="w-100">
          <Space style={{ width: "100%" }} direction="vertical">
            <Select
              mode="multiple"
              allowClear
              style={{ width: "100%", color: "#000" }}
              placeholder="Please select User"
              options={[
                {
                  value: "Assigned",
                  label: "Assigned",
                },
                {
                  value: "Unassigned",
                  label: "Unassigned",
                },
              ]}
              onChange={(value) => setSelectedUser(value)}
              value={selectedUser}
            />
          </Space>
          {/* <select
            name=""
            id=""
            className="w-100"
            style={{
              borderRadius: "8px",
              border: "none",
              background: "#E6EBF3",
              height: "30px",
              padding: "5px",
            }}
            value={selectedUser}
            onChange={(e) => setSelectedUser(e.target.value)}
          >
            <option value="">Select</option>
            <option value="Assigned">Assigned</option>
            <option value="Unassigned">Unassigned</option>
          </select> */}
          {/* <Multiselect
            options={[
              { name: "Assigned", id: 1 },
              { name: "Unassigned", id: 2 },
            ]}
            selectedValues={selectedUser}
            onSelect={(selectedList) => setSelectedUser(selectedList)}
            onRemove={(selectedList) => setSelectedUser(selectedList)}
            displayValue="name" // The value to display in the dropdown
            closeIcon="cancel" // Optional: Close icon for dropdown
            style={{ chips: { background: "#1C449C", color: "#fff" } }} // Optional: Chip styles
          /> */}
        </div>
      </div>

      <div className="mt-3">
        <label htmlFor="">PRIORITY</label>
        <div className="w-100">
          <Space style={{ width: "100%" }} direction="vertical">
            <Select
              mode="multiple"
              allowClear
              style={{ width: "100%", color: "#000" }}
              placeholder="Please select Priority"
              options={[
                { value: "Low", label: "Low" },
                { value: "Medium", label: "Medium" },
                { value: "High", label: "High" },
                { value: "Urgent", label: "Urgent" },
              ]}
              onChange={(value) => setSelectedPriority(value)}
              value={selectedPriority}
            />
          </Space>
          {/* <select
            name=""
            id=""
            className="w-100"
            style={{
              borderRadius: "8px",
              border: "none",
              background: "#E6EBF3",
              height: "30px",
              padding: "5px",
            }}
            value={selectedPriority}
            onChange={(e) => setSelectedPriority(e.target.value)}
          >
            <option value="">Select</option>
            <option value="Low">Low</option>
            <option value="Medium">Medium</option>
            <option value="High">High</option>
            <option value="Urgent">Urgent</option>
          </select> */}

          {/* <Multiselect
            options={[
              { category: "priority", value: "Low" },
              { category: "priority", value: "Medium" },
              { category: "priority", value: "High" },
              { category: "priority", value: "Urgent" },
            ]}
            selectedValues={selectedPriority}
            onSelect={(selectedList) => {
              // Add a null check to make sure selectedList contains valid objects
              const selectedValues = selectedList
                .map((item) => item?.value)
                .filter((value) => value !== undefined);
              setSelectedPriority(selectedValues);
            }}
            onRemove={(selectedList) => {
              // Add a null check to ensure safe access to the 'value' property
              const selectedValues = selectedList
                .map((item) => item?.value)
                .filter((value) => value !== undefined);
              setSelectedPriority(selectedValues);
            }}
            displayValue="value" // The value to display in the dropdown
            closeIcon="cancel" // Optional: Close icon for dropdown
            style={{ chips: { background: "#1C449C", color: "#fff" } }} // Optional: Chip styles
          /> */}
        </div>
      </div>

      <div className="mt-3">
        <label htmlFor="">APPOINTMENT STATUS</label>
        <div className="w-100">
          <Space style={{ width: "100%" }} direction="vertical">
            <Select
              mode="multiple"
              allowClear
              style={{ width: "100%", color: "#000" }}
              placeholder="Please select Appointment Status"
              options={[
                { value: "scheduled", label: "Scheduled" },
                { value: "rejected", label: "Rejected" },
                { value: "pending", label: "Pending" },
                { value: "onhold", label: "On Hold" },
                { value: "rescheduled", label: "Rescheduled" },
                { value: "Partially Completed", label: "Partially Completed" },
                { value: "Order Fix Needed", label: "Order Fix Needed" },
                { value: "completed", label: "Completed" },
                { value: "cancelled", label: "Cancelled" },
              ]}
              onChange={(value) => setSelectedStatus(value)}
              value={selectedStatus}
            />
          </Space>
          {/* <select
            name=""
            id=""
            className="w-100"
            style={{
              borderRadius: "8px",
              border: "none",
              background: "#E6EBF3",
              height: "30px",
              padding: "5px",
            }}
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
          >
            <option value="">Select</option>
            <option value="scheduled">Scheduled</option>
            <option value="rejected">Rejected</option>
            <option value="pending">Pending</option>
            <option value="onhold">On Hold</option>
            <option value="rescheduled">Rescheduled</option>
            <option value="Partially Completed">Partially Completed</option>
            <option value="completed">Completed</option>
            <option value="cancelled">Cancelled</option>
          </select> */}
          {/* <Multiselect
            options={[
              { name: "scheduled", id: 1 },
              { name: "rejected", id: 2 },
              { name: "pending", id: 3 },
              { name: "onhold", id: 4 },
              { name: "rescheduled", id: 5 },
              { name: "completed", id: 6 },
            ]}
            selectedValues={selectedStatus}
            onSelect={(selectedList) => setSelectedStatus(selectedList)}
            onRemove={(selectedList) => setSelectedStatus(selectedList)}
            displayValue="name" // The value to display in the dropdown
            closeIcon="cancel" // Optional: Close icon for dropdown
            style={{ chips: { background: "#1C449C", color: "#fff" } }} // Optional: Chip styles
          /> */}
        </div>
      </div>

      <div className="mt-3">
        <label htmlFor="">RECONCILIATION STATUS</label>
        <div className="w-100">
          <Space style={{ width: "100%" }} direction="vertical">
            <Select
              mode="multiple"
              allowClear
              style={{ width: "100%", color: "#000" }}
              placeholder="Please select Reconciliation Status"
              options={[
                { value: "Not Started", label: "Not Started" },
                { value: "In Progress", label: "In Progress" },
                { value: "Order Fix Needed", label: "Order Fix Needed" },
                { value: "Reviewed", label: "Reviewed" },
                { value: "Completed", label: "Completed" },
              ]}
              onChange={(value) => setReconciliationStatus(value)}
              value={reconciliationStatus}

            />
          </Space>
          {/* <select
            name=""
            id=""
            className="w-100"
            style={{
              borderRadius: "8px",
              border: "none",
              background: "#E6EBF3",
              height: "30px",
              padding: "5px",
            }}
            value={reconciliationStatus}
            onChange={(e) => setReconciliationStatus(e.target.value)}
          >
            <option value="">Select</option>
            <option value="Not Started">Not Started</option>
            <option value="In Progress">In Progress</option>
            <option value="Order Fix Needed">Order Fix Needed</option>
            <option value="Reviewed">Reviewed</option>
            <option value="Completed">Completed</option>
          </select> */}
          {/* <Multiselect
            options={[
              { name: "Not Started", id: 1 },
              { name: "In Progress", id: 2 },
              { name: "Order Fix Needed", id: 3 },
              { name: "Reviewed", id: 4 },
              { name: "Completed", id: 5 },
            ]}
            selectedValues={reconciliationStatus}
            onSelect={(selectedList) => setReconciliationStatus(selectedList)}
            onRemove={(selectedList) => setReconciliationStatus(selectedList)}
            displayValue="name" // The value to display in the dropdown
            closeIcon="cancel" // Optional: Close icon for dropdown
            style={{ chips: { background: "#1C449C", color: "#fff" } }} // Optional: Chip styles
          /> */}
        </div>
      </div>

      <div className="mt-3">
        <label htmlFor="">JOB TYPE</label>
        <div className="w-100">
          <Space style={{ width: "100%" }} direction="vertical">
            <Select
              mode="multiple"
              allowClear
              style={{ width: "100%", color: "#000" }}
              placeholder="Please select Job Type"
              options={[
                { value: "Backfill Order", label: "Backfill Order" },
                { value: "Content Update (SD Card)", label: "Content Update (SD Card)" },
                { value: "Check-In", label: "Check-In" },
                { value: "Content Update (Wi-Fi)", label: "Content Update (Wi-Fi)" },
                { value: "De-install", label: "De-install" },
                { value: "De-install (to be moved)", label: "De-install (to be moved)" },
                { value: "De-install (to be re-installed)", label: "De-install (to be re-installed)" },
                { value: "Demo Unit", label: "Demo Unit" },
                { value: "Follow Up Install", label: "Follow Up Install" },
                { value: "Misc. Service", label: "Misc. Service" },
                { value: "Multiple Services", label: "Multiple Services" },
                { value: "New Order", label: "New Order" },
                { value: "Parts Only", label: "Parts Only" },
                { value: "Re-install (at new location)", label: "Re-install (at new location)" },
                { value: "Reconnect & App Update", label: "Reconnect & App Update" },
                { value: "Replacement", label: "Replacement" },
                { value: "Reship", label: "Reship" },
                { value: "Retrieval/Pick Up", label: "Retrieval/Pick Up" },
                { value: "Unit Exchange", label: "Unit Exchange" },
                { value: "Upsell Order", label: "Upsell Order" },
                { value: "Mobile Router", label: "Mobile Router" }
              ]}
              onChange={(value) => setSelectedJobType(value)}
              value={selectedJobType}
            />
          </Space>
          {/* <select
            name=""
            id=""
            className="w-100"
            style={{
              borderRadius: "8px",
              border: "none",
              background: "#E6EBF3",
              height: "30px",
              padding: "5px",
            }}
            value={selectedJobType}
            onChange={(e) => setSelectedJobType(e.target.value)}
          >
            <option value="">Select</option>
            <option value="Backfill Order">Backfill Order</option>
            <option value="Content Update (SD Card)">
              Content Update (SD Card)
            </option>
            <option value="Check-In">Check-In</option>
            <option value="Content Update (Wi-Fi)">
              Content Update (Wi-Fi)
            </option>
            <option value="De-install"> De-install</option>
            <option value="De-install (to be moved)">
              De-install (to be moved)
            </option>
            <option value="De-install (to be re-installed)">
              De-install (to be re-installed)
            </option>
            <option value="Demo Unit">Demo Unit</option>
            <option value="Follow Up Install">Follow Up Install</option>
            <option value="Misc. Service">Misc. Service</option>
            <option value="Multiple Services">Multiple Services</option>
            <option value="New Order"> New Order </option>
            <option value="Parts Only"> Parts Only </option>
            <option value="Re-install (at new location)">
              {" "}
              Re-install (at new location){" "}
            </option>
            <option value="Reconnect & App Update">
              Reconnect & App Update
            </option>
            <option value="Replacement">Replacement</option>
            <option value="Reship">Reship</option>
            <option value="Retrieval/Pick Up">Retrieval/Pick Up</option>
            <option value="Unit Exchange"> Unit Exchange</option>
            <option value="Upsell Order">Upsell Order</option>
          </select> */}
          {/* <Multiselect
            options={[
              { name: "Backfill Order", id: 1 },
              { name: "Content Update (SD Card)", id: 2 },
              { name: "Content Update (Wi-Fi)", id: 3 },
              { name: "De-install", id: 4 },
              { name: "De-install (to be moved)", id: 5 },
              { name: "De-install (to be re-installed)", id: 6 },
              { name: "Demo Unit", id: 7 },
              { name: "Follow Up Install", id: 8 },
              { name: "Multiple Services", id: 9 },
              { name: "Misc. Service", id: 10 },
              { name: "New Order", id: 11 },
              { name: "Parts Only", id: 12 },
              { name: "Re-install (at new location)", id: 13 },
              { name: "Reconnect & App Update", id: 14 },
              { name: "Replacement", id: 15 },
              { name: "Reship", id: 16 },
              { name: "Retrieval/Pick Up", id: 17 },
              { name: "Unit Exchange", id: 18 },
              { name: "Upsell Order", id: 19 },
            ]}
            selectedValues={selectedJobType}
            onSelect={(selectedList) => setSelectedJobType(selectedList)}
            onRemove={(selectedList) => setSelectedJobType(selectedList)}
            displayValue="name" // The value to display in the dropdown
            closeIcon="cancel" // Optional: Close icon for dropdown
            style={{ chips: { background: "#1C449C", color: "#fff" } }} // Optional: Chip styles
          /> */}
        </div>
      </div>

      <div className="mt-3">
        <label htmlFor="">OWNER</label>
        <div className="w-100">
          <Space style={{ width: "100%" }} direction="vertical">
            <Select
              mode="multiple"
              allowClear
              style={{ width: "100%", color: "#000" }}
              placeholder="Please select Owner"
              options={[
                { value: "Midwest", label: "Midwest" },
                { value: "Northeast", label: "Northeast" },
                { value: "Southeast", label: "Southeast" },
                { value: "Southwest", label: "Southwest" },
                { value: "West", label: "West" },
              ]}
              onChange={(value) => setSelectedOwner(value)}
              value={selectedOwner}
            />
          </Space>
          {/* <select
            name=""
            id=""
            className="w-100"
            style={{
              borderRadius: "8px",
              border: "none",
              background: "#E6EBF3",
              height: "30px",
              padding: "5px",
            }}
            value={selectedOwner}
            onChange={(e) => setSelectedOwner(e.target.value)}
          >
            <option value="">Select</option>
            <option value="Midwest">Midwest</option>
            <option value="Northeast">Northeast</option>
            <option value="Southeast">Southeast</option>
            <option value="Southwest">Southwest</option>
            <option value="West">West</option>
          </select> */}
          {/* <Multiselect
            options={[
              { name: "South", id: 1 },
              { name: "Central", id: 2 },
              { name: "Midwest", id: 3 },
              { name: "East", id: 4 },
              { name: "West", id: 5 },
              { name: "Northeast", id: 6 },
              { name: "Southeast", id: 7 },
            ]}
            selectedValues={selectedOwner}
            onSelect={(selectedList) => setSelectedOwner(selectedList)}
            onRemove={(selectedList) => setSelectedOwner(selectedList)}
            displayValue="name" // The value to display in the dropdown
            closeIcon="cancel" // Optional: Close icon for dropdown
            style={{ chips: { background: "#1C449C", color: "#fff" } }} // Optional: Chip styles
          /> */}
        </div>
      </div>

      {/* <div className="mt-3 text-center">
        <p>Radius: 5 miles</p>
        <input type="range" name="" id="" className="w-100" />
      </div> */}
    </div>
  );

  return (
    <div
      className={` ${location.pathname === "/update" ? "sidebarnone" : "sidebar"
        }`}
    >
      <div>
        {/* Search input */}
        <div className="position-relative">
          <input
            onChange={handleChange}
            type="search"
            value={searchText}
            className="form-control form-control-sm pe-7"
            placeholder="Search Orders"
          />
          {searchText === "" && (
            <IoIosSearch
              className="position-absolute top-50 translate-middle-y text-muted pe-none fs-5"
              style={{ right: '0.5rem', pointerEvents: 'none' }}
              aria-hidden="true"
            />
          )}
        </div>


        {/* Filter and Sort Section */}
        <div
          className="mt-4 d-flex justify-content-between"
          style={{ fontSize: "14px" }}
        >
          <Popover
            content={contentData()}
            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
            placement="bottomLeft"
          >
            <div
              className="d-flex align-items-center"
              style={{ gap: "8px", cursor: "pointer" }}
            >
              <img src="/images/filter.png" alt="" className="imgcls" />
              <div>Filter: {selectedFilter}</div>
            </div>
          </Popover>

          <div className="d-flex gap-2">
            <div
              className="d-flex align-items-center"
              style={{ gap: "8px", cursor: "pointer" }}
              onClick={() => {
                handleDateSortClick();
                setSelectedFilter("All");
              }}
            >
              <div>Appointment Date</div>
              {sortOrder === "desc" ? (
                <svg
                  width="10"
                  height="14"
                  viewBox="0 0 10 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 5.66675L5 0.666748L10 5.66675H0Z"
                    fill="#414C60"
                  />
                  <path
                    opacity="0.5"
                    d="M10 8.66675L5 13.6667L1.39079e-06 8.66675L10 8.66675Z"
                    fill="#414C60"
                  />
                </svg>
              ) : sortOrder === "asc" ? (
                <svg
                  width="10"
                  height="14"
                  viewBox="0 0 10 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 5.66675L5 0.666748L10 5.66675H0Z"
                    fill="#414C60"
                    opacity="0.5"
                  />
                  <path
                    d="M10 8.66675L5 13.6667L1.39079e-06 8.66675L10 8.66675Z"
                    fill="#414C60"
                  />
                </svg>
              ) : (
                <svg
                  width="10"
                  height="14"
                  viewBox="0 0 10 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 5.66675L5 0.666748L10 5.66675H0Z"
                    fill="#414C60"
                    opacity="0.5"
                  />
                  <path
                    d="M10 8.66675L5 13.6667L1.39079e-06 8.66675L10 8.66675Z"
                    fill="#414C60"
                    opacity="0.5"
                  />
                </svg>
              )}

              <svg
                width="32"
                height="31"
                viewBox="0 0 32 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="32" height="30.3333" rx="6" fill="#1C449C" />
                <path
                  d="M12.3333 17C12.0736 17 11.8559 16.9122 11.6802 16.7365C11.5045 16.5608 11.4167 16.3431 11.4167 16.0833C11.4167 15.8236 11.5045 15.6059 11.6802 15.4302C11.8559 15.2545 12.0736 15.1667 12.3333 15.1667C12.5931 15.1667 12.8108 15.2545 12.9865 15.4302C13.1622 15.6059 13.25 15.8236 13.25 16.0833C13.25 16.3431 13.1622 16.5608 12.9865 16.7365C12.8108 16.9122 12.5931 17 12.3333 17ZM16 17C15.7403 17 15.5226 16.9122 15.3469 16.7365C15.1712 16.5608 15.0833 16.3431 15.0833 16.0833C15.0833 15.8236 15.1712 15.6059 15.3469 15.4302C15.5226 15.2545 15.7403 15.1667 16 15.1667C16.2597 15.1667 16.4774 15.2545 16.6531 15.4302C16.8288 15.6059 16.9167 15.8236 16.9167 16.0833C16.9167 16.3431 16.8288 16.5608 16.6531 16.7365C16.4774 16.9122 16.2597 17 16 17ZM19.6667 17C19.4069 17 19.1892 16.9122 19.0135 16.7365C18.8378 16.5608 18.75 16.3431 18.75 16.0833C18.75 15.8236 18.8378 15.6059 19.0135 15.4302C19.1892 15.2545 19.4069 15.1667 19.6667 15.1667C19.9264 15.1667 20.1441 15.2545 20.3198 15.4302C20.4955 15.6059 20.5833 15.8236 20.5833 16.0833C20.5833 16.3431 20.4955 16.5608 20.3198 16.7365C20.1441 16.9122 19.9264 17 19.6667 17ZM9.58333 24.3333C9.07917 24.3333 8.64757 24.1538 8.28854 23.7948C7.92951 23.4358 7.75 23.0042 7.75 22.5V9.66667C7.75 9.1625 7.92951 8.7309 8.28854 8.37188C8.64757 8.01285 9.07917 7.83333 9.58333 7.83333H10.5V6H12.3333V7.83333H19.6667V6H21.5V7.83333H22.4167C22.9208 7.83333 23.3524 8.01285 23.7115 8.37188C24.0705 8.7309 24.25 9.1625 24.25 9.66667V22.5C24.25 23.0042 24.0705 23.4358 23.7115 23.7948C23.3524 24.1538 22.9208 24.3333 22.4167 24.3333H9.58333ZM9.58333 22.5H22.4167V13.3333H9.58333V22.5ZM9.58333 11.5H22.4167V9.66667H9.58333V11.5Z"
                  fill="white"
                />
              </svg>
            </div>

            {/* Map SVG */}
            <div onClick={handleOpenMap}>
              <svg
                width="32"
                height="31"
                viewBox="0 0 32 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="32" height="30.3333" rx="6" fill="#1C449C" />
                <path
                  d="M16 4.66667C12.3181 4.66667 9.33333 7.65144 9.33333 11.3333C9.33333 16.0448 16 25.8333 16 25.8333C16 25.8333 22.6667 16.0448 22.6667 11.3333C22.6667 7.65144 19.6819 4.66667 16 4.66667ZM16 14.6667C14.8974 14.6667 14 13.7693 14 12.6667C14 11.5641 14.8974 10.6667 16 10.6667C17.1026 10.6667 18 11.5641 18 12.6667C18 13.7693 17.1026 14.6667 16 14.6667Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Quick Filter Buttons */}
        <div className="mt-3">
          <div className="d-flex justify-content-between gap-2">
            <button
              className={`d-flex justify-content-center align-items-center gap-2 ${activeFilterButton?.value === "New Orders"
                ? "active_filter_button"
                : "flitter_Button"
                }`}
              onClick={() => handleButtonFilter("New Orders")}
              style={{ flex: 1 }} // Makes buttons take equal width in row
            >
              <IoDocumentTextOutline className="document_icon" />
              <div className="text-center w-100 mt-2">
                {" "}
                {/* Ensures text centers horizontally */}
                <span className="text_style">All Orders</span>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "bolder",
                    fontFamily: "arial",
                  }}
                >
                  Count:{workOrderCount.total_orders}
                </p>
              </div>
            </button>

            <button
              className={`d-flex justify-content-center align-items-center gap-2 ${activeFilterButton?.value === "pending"
                ? "active_filter_button"
                : "flitter_Button"
                }`}
              onClick={() =>
                handleButtonFilter({ category: "apptStatus", value: "pending" })
              }
              style={{ flex: 1 }}
            >
              <GoClock className="clock_icon" />
              <div className="text-center w-100 mt-2">
                <span className="text_style">Pending Orders</span>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "bolder",
                    fontFamily: "arial",
                  }}
                >
                  Count: {workOrderCount.pending}
                </p>
              </div>
            </button>
          </div>

          <div className="d-flex justify-content-between gap-2 mt-3">
            <button
              className={`d-flex justify-content-center align-items-center gap-2 ${activeFilterButton?.value === "scheduled"
                ? "active_filter_button"
                : "flitter_Button"
                }`}
              onClick={() =>
                handleButtonFilter({
                  category: "apptStatus",
                  value: "scheduled",
                })
              }
              style={{ flex: 1 }}
            >
              <MdOutlineCalendarMonth className="calendar_icon" />
              <div className="text-center w-100 mt-2">
                <span className="text_style">Scheduled Orders</span>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "bolder",
                    fontFamily: "arial",
                  }}
                >
                  Count: {workOrderCount.scheduled + workOrderCount?.rescheduled}
                </p>
              </div>
            </button>

            <button
              className={`d-flex justify-content-center align-items-center gap-2 ${activeFilterButton?.value === "completed"
                ? "active_filter_button"
                : "flitter_Button"
                }`}
              onClick={() =>
                handleButtonFilter({
                  category: "apptStatus",
                  value: "completed",
                })
              }
              style={{ flex: 1 }}
            >
              <FaRegCheckCircle className="check_circle" />
              <div className="text-center w-100 mt-2">
                <span className="text_style">Completed Orders</span>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "bolder",
                    fontFamily: "arial",
                  }}
                >
                  Count: {workOrderCount.completed}
                </p>
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Total Results */}
      <div className="mt-3 text-left" style={{ fontSize: "12px" }}>
        Showing {totalWorkOrders} results
      </div>

      <div>{children}</div>
    </div>
  );
};

export default Index;
